import { Directive, ChangeWindow } from '../../../types';

/**
 * Storage class configuration for Kubernetes
 */
export interface StorageClass {
  name: string;
  allowVolumeExpansion: boolean;
}

/**
 * Ingress controller configuration for Kubernetes
 */
export interface IngressController {
  name: string;
}

/**
 * Form data for Kubernetes Setup Policy
 */
export interface KubernetesSetupFormData {
  // Networking - Services
  /** Use LoadBalancer service type */
  useLoadBalancer: boolean;

  // Networking - Ingresses
  /** List of ingress controllers */
  ingressControllers: IngressController[];
  /** Allow using no ingress class */
  allowNoneIngressClass: boolean;
  /** Ingress availability per namespace */
  ingressAvailabilityPerNamespace: boolean;
  /** Restrict standard user ingress writes */
  restrictStandardUserIngressW: boolean;

  // Change Window
  /** GitOps change window configuration */
  changeWindow: ChangeWindow;

  // Resources and Metrics
  /** Enable resource over-commit */
  enableResourceOverCommit: boolean;
  /** Resource over-commit percentage */
  resourceOverCommitPercentage: number;
  /** Use server metrics */
  useServerMetrics: boolean;

  // Storage
  /** List of storage classes */
  storageClasses: StorageClass[];
}

/**
 * Ingress class configuration for the backend API
 */
export interface IngressClass {
  name: string;
  type: string;
  globallyBlocked: boolean;
  blockedNamespaces: string[];
}

/**
 * Stored/API payload for Kubernetes Setup Policy
 * This matches the actual backend API structure
 */
export interface KubernetesSetupPolicyPayload {
  UseLoadBalancer: Directive<boolean>;
  UseServerMetrics: Directive<boolean>;
  EnableResourceOverCommit: Directive<boolean>;
  ResourceOverCommitPercentage: Directive<number>;
  IngressAvailabilityPerNamespace: Directive<boolean>;
  AllowNoneIngressClass: Directive<boolean>;
  // StorageClasses: Directive<StorageClass[]>;
  StorageClasses: Array<Directive<StorageClass>>;
  IngressClasses: Array<Directive<IngressClass>>;
  RestrictStandardUserIngressW: Directive<boolean>;
  DeploymentOptions: Directive<Record<string, unknown>>;
  EndpointChangeWindow: Directive<ChangeWindow>;
}

/**
 * Default initial values for Kubernetes Setup Policy (create mode)
 */
export const KUBERNETES_SETUP_INITIAL_VALUES: KubernetesSetupFormData = {
  useLoadBalancer: false,
  ingressControllers: [],
  allowNoneIngressClass: false,
  ingressAvailabilityPerNamespace: false,
  restrictStandardUserIngressW: false,
  changeWindow: {
    Enabled: false,
    StartTime: '22:00',
    EndTime: '02:00',
  },
  enableResourceOverCommit: false,
  resourceOverCommitPercentage: 0,
  useServerMetrics: false,
  storageClasses: [],
};
